"use client";

import { MouseEventHandler, useRef, useState } from "react";
import IconPlayVideo from "../icons/IconPlayVideo";

export default function VideoLightbox({
  src,
  poster,
  alt,
}: {
  src?: string | null;
  poster: string;
  alt: string;
}) {
  const [isVisible, setIsVisible] = useState(false);
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const closeVideo: MouseEventHandler = (e) => {
    if (e.target === e.currentTarget) {
      e.preventDefault();
      videoRef.current?.pause();
      setIsVisible(false);
    }
  };

  const playVideo = () => {
    if (!src) return;

    setIsVisible(true);
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play();
    }
  };

  return (
    <div
      className={`video-lightbox ${isVisible ? "video-lightbox--visible" : ""}`}
    >
      <div className="video-lightbox-poster" onClick={playVideo}>
        {!!src && (
          <span className="faux-play-btn">
            <IconPlayVideo />
          </span>
        )}
        <img src={poster} alt={alt} />
      </div>
      {!!src && (
        <div className="video-lightbox-overlay" onClick={closeVideo}>
          <div className="video-lightbox-overlay-container">
            <a
              className="video-lightbox-close"
              aria-label="Close"
              role="button"
              onClick={closeVideo}
            >
              <b></b>
              <b></b>
            </a>
            <video
              src={src}
              width="780"
              height="auto"
              controls
              poster={poster}
              preload="auto"
              ref={videoRef}
            ></video>
          </div>
        </div>
      )}
    </div>
  );
}
